import type {SxProps, Theme} from '@mui/material/styles';
import type {LinkProps as NextLinkProps} from 'next/link';
import type React from 'react';

export type LinkSize = 'lg' | 'sm';

export interface LinkBaseProps
  extends Omit<NextLinkProps, 'as' | 'href'>,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps | 'href'> {
  href: string;
  size?: LinkSize;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
}

export const LINK_FONT_SIZE = {lg: 'body-2', sm: 'body-3'} as const;

// `sx` must be excluded so it is consumed by the style engine, not forwarded to
// the underlying <a> (a custom shouldForwardProp replaces MUI's default, which
// normally strips `sx`).
export function linkShouldForwardProp(propName: PropertyKey): boolean {
  return !['oSize', 'oType', 'sx'].includes(propName as string);
}
